import * as Yup from 'yup';
import { ICommunicationValues } from './types';

const checkboxError = 'Select at least one checkbox';

const commonTextFieldValidation = Yup.string().nullable().required();

const createConditionalValidator = (
  conditionField: string,
  conditionValue: boolean | string,
  validator: Yup.AnySchema,
) => {
  return Yup.mixed().when(conditionField, {
    is: (value: boolean) => !!value === conditionValue,
    then: validator,
  });
};

const atLeastOneRequired = (fieldName: string, message: string) => Yup.array()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  .test(fieldName, message, (value: (string | null)[] | any) => value
    && value.length > 0 && value.every((item: string | null) => !!item)).required(message);
    type Omitted = 'selectedEmailTemplate' | 'selectedSMSTemplate';
    export type ICommunicationValuesForm = Omit<ICommunicationValues, Omitted>;
    export const customerCommunicationSchema: Yup.SchemaOf<ICommunicationValuesForm> = Yup.object()
      .shape(
        {
          id: Yup.string(),
          isEmail: Yup.boolean(),
          isSms: Yup.boolean(),
          isAdverseAction: Yup.boolean(),
          isSafeToContact: Yup.boolean(),
          emailTemplateId: createConditionalValidator('isEmail', true, commonTextFieldValidation),
          smsTemplateId: createConditionalValidator('isSms', true, commonTextFieldValidation),
          fromEmail: createConditionalValidator('isEmail', true, commonTextFieldValidation),
          fromSid: createConditionalValidator('isSms', true, commonTextFieldValidation),
          delayInMinutes: Yup.number()
            .min(1, 'Delay must be at most 1 minute')
            .max(2000000)
            .required('Delay must be at least 1 minute'),
          excludedStates: Yup.array(),
          includedLenders: Yup.array(),
          includedLeadSources: Yup.array(),
          workflowSteps: atLeastOneRequired('is-selected-workflow', 'Workflow Step is required'),
          workflowIds: atLeastOneRequired('at-least-one-workflow-step', 'Workflow is required'),
        },
        [['isEmail', 'isSms']]
      )
      .test('at-least-one-checkbox', checkboxError, function (obj) {
        if (obj.isEmail || obj.isSms) {
          return true;
        }

        return new Yup.ValidationError(checkboxError, null, 'isSms');
      });

export const useConfigureEmailsValidationSchema = (emails: string[]) => Yup.object().shape({
  email: Yup.string().email().required().notOneOf(emails, 'This email already exists')
});

export const useConfigureSidsValidationSchema = () => {
  return Yup.object().shape({
    source: Yup.string()
      .required('Source is required'),
    sid: Yup.string()
      .required('SID is required'),
  });
};